import React from 'react';
import {
  Box,
  Avatar
} from '@mui/material';

export default function ProfilePictureDisplay({ currentPhotoURL, displayName, email }) {

  // Get initials from display name or email
  const getInitials = () => {
    if (displayName && displayName.trim()) {
      return displayName
        .split(' ')
        .map(name => name.charAt(0))
        .join('')
        .toUpperCase()
        .substring(0, 2);
    }
    
    if (email) {
      return email.charAt(0).toUpperCase();
    }
    
    return 'U';
  };

  // If there's a photo URL, use it, otherwise show initials
  const shouldShowPhoto = currentPhotoURL && currentPhotoURL.startsWith('http');

  return (
    <Box sx={{ textAlign: 'center' }}>
      {/* Profile Picture Display */}
      <Box sx={{ mb: 2 }}>
        <Avatar
          src={shouldShowPhoto ? currentPhotoURL : undefined}
          alt={displayName || 'User'}
          sx={{
            width: 120,
            height: 120,
            fontSize: '3rem',
            border: '4px solid',
            borderColor: 'grey.300',
            backgroundColor: shouldShowPhoto ? 'transparent' : 'primary.main'
          }}
        >
          {!shouldShowPhoto && getInitials()}
        </Avatar>
      </Box>
    </Box>
  );
}
